import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPlus } from "@fortawesome/free-solid-svg-icons"

export const Plus = (props) => {
  return <FontAwesomeIcon faIcon={faPlus} {...props} />
}
